import React, { useEffect, useState } from 'react'
import Header from '../Component/Header'
import Footer from '../Component/Footer'
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Autoplay } from "swiper/modules";

function Services({ serviceId, servicename }) {
    const [services, setServices] = useState([]); // State to store services
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");


    useEffect(() => {
        const fetchServices = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/getcategories`);
                if (!response.ok) {
                    throw new Error(`Error: ${response.status}`);
                }
                const result = await response.json();

                // Transform the fetched data to match your services structure
                const transformedData = result.data.map((item) => ({
                    id: item.category_id,
                    name: item.category,
                    image: `${item.categoryIcon}`, // Prepend the image URL from the environment variable
                }));

                setServices(transformedData);
                setLoading(false);
            } catch (err) {
                setError(err.message);
                setLoading(false);
            }
        };

        fetchServices();
    }, []);

    return (
        <>
            <Header />
            <div style={{ backgroundColor: "#FFFFFF" }}>
                {/* Service Start */}
                <div className="container-xxl py-4 my-1">
                    <div className="container py-5"></div>
                    <div
                        className="text-center mx-auto mb-5 wow fadeInUp"
                        data-wow-delay="0.1s"
                        style={{ maxWidth: 500 }}
                    >
                        <p className="display-6 text-primary text-uppercase mb-2">Our Services</p>
                        <h1 className="display-6 mb-4">We Provide Best Professional Services</h1>
                    </div>

                    {loading && <p className="text-center">Loading services...</p>}
                    {error && <p className="text-center text-danger">{error}</p>}

                    {!loading && !error && (
                        <Swiper
                            modules={[Navigation, Autoplay]}
                            spaceBetween={20}
                            navigation
                            autoplay={{
                                delay: 2000,
                                disableOnInteraction: false,
                                pauseOnMouseEnter: true,
                            }}
                            speed={1000}
                            breakpoints={{
                                0: {
                                    slidesPerView: 1,
                                    spaceBetween: 10,
                                },
                                576: {
                                    slidesPerView: 2,
                                    spaceBetween: 15,
                                },
                                768: {
                                    slidesPerView: 3,
                                    spaceBetween: 20,
                                },
                                992: {
                                    slidesPerView: 4,
                                    spaceBetween: 30,
                                },
                            }}
                            style={{ paddingBottom: '40px' }} // Optional styling for navigation space
                        >
                            {services.map((service) => (
                                <SwiperSlide
                                    key={service.id}
                                    style={{ width: 'auto' }} // important so slides don't shrink too small
                                >
<Link
    to={`/service/${service.id}/${encodeURIComponent(service.name)}`}
    className="text-decoration-none"
>
                                        <div className="service-item d-flex flex-column p-3 pb-0" style={{ backgroundColor: "#f8f9fa", minWidth: '250px' }}>
                                            <div
                                                className="position-relative"
                                                style={{ height: '350px', overflow: 'hidden' }}
                                            >
                                                <img
                                                    className="img-fluid"
                                                    src={service.image}
                                                    alt={service.name}
                                                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                                />
                                            </div>
                                            <div className="text-center p-4">
                                                <h4>{service.name}</h4>
                                            </div>
                                        </div>
                                    </Link>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    )}
                </div>
                <Footer />
            </div>
        </>
    )
}

export default Services